import React from 'react'
import AnalyticsTooltip from 'shared/components/info-tooltip/info-tooltip.js'
import styled from 'styled-components'
import { giphyLightGrey } from '@giphy/js-brand'
import { Title } from '@giphy/react-giphy-brand'
import { mobile } from 'shared/util/media-query'
import { useMedia } from 'react-use'

const LargeDashboardStatistic = styled(Title)`
    font-size: 68px;
    text-align: left;
    line-height: 1;

    ${mobile.css`
        font-size: 33px;
    `}
`

const SubheaderContainer = styled.div`
    position: relative;
    display: flex;
`

const Subheader = styled.p`
    text-align: left;
    margin: 0;
    color: ${giphyLightGrey};
    font-family: interface;
    font-weight: 600;
    text-transform: none;
    font-size: 18px;

    ${mobile.css`
        font-size: 14px;
    `}
`

type Props = {
    index: number
    stat: string
    title: string
    toolTipText: string
}

const ShowStatistics = ({ index, stat, title, toolTipText }: Props) => {
    const isMobile = useMedia(mobile.query)
    return (
        <LargeDashboardStatistic>
            {stat}
            <SubheaderContainer>
                <Subheader>{title}</Subheader>
                {!isMobile && <AnalyticsTooltip index={index} toolTipText={toolTipText} tooltip={true} />}
            </SubheaderContainer>
        </LargeDashboardStatistic>
    )
}

export default ShowStatistics
